export default "__VITE_ASSET__YYrrjI5L__"